module.exports = __webpack_public_path__ + "static/media/sum.668bfd39.png";